import { isCrFilter } from '../../../../customer-review-star-filter/types';
import { isSortParameter } from '../../../types';
import { reloadReviewList } from '../reload-review-list';

export const triggerReloadForNewPage = async (newPage: number, rootElement: HTMLElement) => {
    const searchParams = new URLSearchParams(location.search);
    await reloadReviewList(rootElement, readFilterFromUrlParameter(searchParams), readSortFromUrlParameter(searchParams), newPage);
};

const readFilterFromUrlParameter = (searchParams: URLSearchParams) => {
    const filterUrlParam = searchParams.get('filter');
    return filterUrlParam && isCrFilter(filterUrlParam) ? filterUrlParam : undefined;
};

const readSortFromUrlParameter = (searchParams: URLSearchParams) => {
    const sortUrlParam = searchParams.get('sort');
    return sortUrlParam && isSortParameter(sortUrlParam) ? sortUrlParam : undefined;
};
